export default {
  eyebrow: 'Partnerportal',
  title: 'Betalingsgebyrer',
  description:
    'Du betaler Stripes gebyrer på hver onlinebetaling. Det betalingsgebyr, der angives her, opkræves dine restauranter for at dække dem, medmindre en restaurant har sin egen sats.',
  card_title: 'Standardbetalingsgebyr',
  hint: 'Procent i %, plus et valgfrit fast beløb og minimumsbeløb pr. betaling. „Enhver betalingsmetode“ gælder, når der ikke findes en metodespecifik sats. En ændring gælder for betalinger, der foretages, efter at den er gemt.',
  hint_single:
    'Betalingsgebyret gælder for alle onlinebetalingsmetoder, der ikke har en egen sats. En ændring gælder for betalinger, der foretages, efter den er gemt.',
  hidden_rates:
    'Nogle betalingsmetoder har også deres egen sats, som din platformssupport har fastsat. De gælder i stedet for denne sats.',
  empty: {
    title: 'Der er ikke angivet noget standardbetalingsgebyr',
    description:
      'Indtil du fastsætter et, eller bekræfter, at du ikke opkræver dine restauranter noget behandlingsgebyr, kan dine restauranter på Stripe ikke gå live, og live restauranter modtager ingen onlinebetalinger (kontant virker stadig).',
  },
  consent: {
    give: 'Vi betaler selv Stripes gebyrer (bekræft 0 % margin)',
    given_title: '0 % margin bekræftet',
    given:
      'Bekræftet af {{name}} den {{date}}: restauranter uden egen sats opkræves intet behandlingsgebyr, og du betaler Stripes gebyrer på deres betalinger.',
    unknown_manager: 'en tidligere manager',
    withdraw: 'Træk tilbage',
    withdraw_confirm: {
      title: 'Træk bekræftelsen af 0 % margin tilbage?',
      description:
        'Restauranter uden en egen sats kan så ikke gå live, og live-restauranter holder op med at modtage onlinebetalinger, indtil du fastsætter en sats eller bekræfter igen.',
    },
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  toasts: {
    load_error: 'Dine betalingsgebyrer kunne ikke indlæses.',
    failed_to_save_changes: 'Dine betalingsgebyrer kunne ikke gemmes.',
    changes_got_saved: 'Betalingsgebyrer gemt',
    consent_given: '0 % margin bekræftet',
    consent_withdrawn: 'Bekræftelse trukket tilbage',
  },
};
